import { render, staticRenderFns } from "./MenuReportExpenses.vue?vue&type=template&id=7af453d6&"
import script from "./MenuReportExpenses.vue?vue&type=script&lang=js&"
export * from "./MenuReportExpenses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports